<script>
import base from './base.vue';
export default {
    extends:base,
    data(){
        return{
            title:'领料出库单',
            isPurchase:3,
            baseNum:'/material/order/generateOutRecordNum',
        }
    },
    methods:{
        checkend(obj){
            if(this.editMode==1){
                obj.id = this.orderid;
                this.$api.editOutRecord(obj).then(res=>{
                    if(res.data.code==1){
                        this.$notify({
                            title: "编辑领料出库单",
                            message: "编辑成功",
                            type: "success",
                            duration: 1000,
                        });
                        this.$router.push('/ppick');
                    }else{
                        this.$common.error('编辑失败');
                        this.lock = false;
                    }
                })
            }else{
                this.$api.createOutRecord(obj).then(res=>{
                    if(res.data.code==1){
                        this.$notify({
                            title: "新增领料出库单",
                            message: "新增成功",
                            type: "success",
                            duration: 1000,
                        });
                        this.$router.push('/ppick');
                    }else{
                        this.$common.error('新增失败');
                        this.lock = false;
                    }
                })
            } 
        },
        initEdit:function(){
			this.$api.outRecordDetail({id:this.orderid}).then(res=>{
                if(res.data.code==1){
                    let info = res.data.data;
                    this.mwid = info.ware;
                    if(this.mwid>0){
                        this.$refs.spt.getMProduct(this.mwid,2);
                    }
                    this.remark = info.remark;
                    this.number = info.number;
                    this.time = info.cdate;
                    this.$refs.spt.setData(info.detail,(o,e)=>{
                        o.spkey = e.id,
                        o.pid = e.mid;
                        o.spid = e.msid;
                        o.price = e.price;
                        o.count = e.amount;
                        o.name = e.mnumber +' ' +e.mname+"_"+e.mspec1+"_"+e.mspec2;
                        o.remark = e.remark;
                        o.unit = e.packing;
                        o.inter = e.inter;
                    })
                }
            })
		},
    }
}
</script>